// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleComponent_root__yAq1Q","tabsWrapper":"ArticleComponent_tabsWrapper__RAewZ","tab":"ArticleComponent_tab__JAfvw","active":"ArticleComponent_active__VzN6s"};